export const testimonialsData = {
  website: [
    {
      imagePath: 'sitewide/block_testimonials/testimonial_lucy-marvin.jpg',
      title: 'Joy offers everything and more than we wanted. We love the layout.',
      author: 'Lucy & Marvin',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Mark Fierst Photography',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_nicholas-micah.jpg',
      title: 'Joy thinks of everything when it comes to creating and designing a wedding website.',
      author: 'Nicholas & Micah',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Shay and Olive Photography',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_morgan-abe.jpg',
      title: 'I love the design! Joy looks good and is so intuitive for our guests!',
      author: ' Morgan & Abe',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Liv Lyszyk Photography',
    },
  ],
  saveTheDate: [
    {
      imagePath: 'sitewide/block_testimonials/testimonial_lucy-marvin.jpg',
      title: 'It’s economical, convenient, and allows us to keep in touch with our guests.',
      author: 'Lucy & Marvin',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Mark Fierst Photography',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_malika-dyron.jpg',
      title: 'It was really easy to set up! Joy took the guesswork out of what I should include.',
      author: 'Malika & Dyron',
      dateMarried: 'Married in 2014',
      photoAttribution: '',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_emily-collin.jpg',
      title: 'It’s so customizable! The layouts and suggestions make sure we cover all the bases.',
      author: 'Emily & Collin',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Hand + Arrow Photography',
    },
  ],
  invites: [
    {
      imagePath: 'sitewide/block_testimonials/testimonial_lucy-marvin.jpg',
      title: 'The ease and organization of the invitations and RSVP process has been great.',
      author: 'Lucy & Marvin',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Mark Fierst Photography',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_templatekayla-randy.jpg',
      title: 'Having everything come in and out of the same website is beyond perfect for us.',
      author: 'Kayla & Randy',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Menning Photographic',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_tinamarie-johnny.jpg',
      title: 'My guests can instantly know the details, RSVP and even get to know people.',
      author: 'Tina Marie & Johnny',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Melissa Ivy Photography',
    },
  ],
  guestList: [
    {
      imagePath: 'sitewide/block_testimonials/testimonial_templatekayla-randy.jpg',
      title: 'This alone saves my sanity!',
      author: 'Kayla & Randy',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Menning Photographic',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_jordan-tyler.jpg',
      title: `I’d say definitely use the guest list and RSVP options.`,
      author: 'Jordan & Tyler',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Andrew May Photography',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_malika-dyron.jpg',
      title: 'Have fun with it and launch early - you can start getting addresses and guest count.',
      author: 'Malika & Dyron',
      dateMarried: 'Married in 2014',
      photoAttribution: '',
    },
  ],
  registry: [
    {
      imagePath: 'sitewide/block_testimonials/testimonial_nicholas-micah.jpg',
      title: 'I love how it’s simple and easy to use! I was so excited when I came across Joy.',
      author: 'Nicholas & Micah',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Shay and Olive Photography',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_jordan-tyler.jpg',
      title: 'It takes care of basically everything for the guests!',
      author: 'Jordan & Tyler',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Andrew May Photography',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_lucy-marvin.jpg',
      title: 'It is extremely user-friendly!',
      author: 'Lucy & Marvin',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Mark Fierst Photography',
    },
  ],
  mobileApp: [
    {
      imagePath: 'sitewide/block_testimonials/testimonial_malika-dyron.jpg',
      title: 'I’m looking forward to our guests uploading their pictures of our wedding!',
      author: 'Malika & Dyron',
      dateMarried: 'Married in 2014',
      photoAttribution: '',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_nicholas-micah.jpg',
      title: `This is great for my guests and makes it much easier for them to know what's happening.`,
      author: 'Nicholas & Micah',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Shay and Olive Photography',
    },
    {
      imagePath: 'sitewide/block_testimonials/testimonial_lucy-marvin.jpg',
      title: 'We love the layout and that it displays our awesome engagement photos.',
      author: 'Lucy & Marvin',
      dateMarried: 'Married in 2014',
      photoAttribution: 'Photo by Mark Fierst Photography',
    },
  ],
};
